import React from 'react'
import { makeStyles } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import classNames from 'classnames'

const useStyles = makeStyles(() => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '50px calc(50% - 25px - 5px) calc(50% - 25px - 5px)',
    '@media (max-width: 960px)': {
      gridTemplateColumns: '50px 1fr',
    },
    gridGap: 5,
  },
  indexTitle: {
    textAlign: 'center',
    '@media (max-width: 960px)': {
    },
  },
  frame: {
    backgroundColor: '#dff5fe',
    padding: '8px 10px',
    borderRadius: 10,
  },
  title: {
    flex: 1,
    '@media (max-width: 960px)': {
      gridColumnEnd: 'span 1',
    },
  },
  text: {
    fontWeight: 600,
    userSelect: 'none',
  },
  options: {
    display: 'flex',
    padding: '0',
    '& > div': {
      padding: '8px 0',
      userSelect: 'none',
      flex: 1,
      borderRight: '1px solid white',
      textAlign: 'center',
      fontWeight: 500,
      fontSize: 14,
      '&:last-child': {
        borderRight: 'none',
      },
    },
    '@media (max-width: 960px)': {
      gridColumnEnd: 'span 2',
    },
  },
}))

const indexTitle = 'ردیف'

export default function Header({ title, options = [] }) {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div className={classNames(classes.indexTitle, classes.frame)}>
        <Typography className={classes.text} variant="body2">{indexTitle}</Typography>
      </div>
      <div className={classNames(classes.title, classes.frame)}>
        <Typography className={classes.text} variant="body2">
          {title}
        </Typography>
      </div>
      {window.outerWidth > 960 && (
      <div className={classNames(classes.options, classes.frame)}>
        {options?.map((option) => (
          <div key={option.id}>{option.title}</div>
        ))}
      </div>
      )}
    </div>
  )
}
